import { BankingEntitiesBankAccountNumberFormatEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const bankAccountFormatOptions = (): {
  label: string
  value: BankingEntitiesBankAccountNumberFormatEnum
}[] => [
  {
    label: i18n.t('employee_form.bank_info.formats.iban'),
    value: 'iban',
  },
  {
    label: i18n.t('employee_form.bank_info.formats.sort_code'),
    value: 'sort_code_and_account_number',
  },
  {
    label: i18n.t('employee_form.bank_info.formats.routing_number'),
    value: 'routing_number_and_account_number',
  },
  {
    label: i18n.t('employee_form.bank_info.formats.bank_name_and_account_number'),
    value: 'bank_name_and_account_number',
  },
  {
    label: i18n.t('employee_form.bank_info.formats.clabe'),
    value: 'clabe',
  },
  {
    label: i18n.t('employee_form.bank_info.formats.other'),
    value: 'other',
  },
]

const countriesWithIBAN = [
  'al',
  'ad',
  'at',
  'az',
  'bh',
  'by',
  'be',
  'ba',
  'bg',
  'cr',
  'hr',
  'cy',
  'cz',
  'dk',
  'do',
  'sv',
  'ee',
  'fo',
  'fi',
  'fr',
  'ge',
  'de',
  'gi',
  'gr',
  'gl',
  'gt',
  'hu',
  'is',
  'iq',
  'il',
  'it',
  'jo',
  'kz',
  'xk',
  'kw',
  'lv',
  'lb',
  'li',
  'lt',
  'lu',
  'mk',
  'mt',
  'mr',
  'mu',
  'md',
  'mc',
  'me',
  'nl',
  'no',
  'pk',
  'ps',
  'pl',
  'pt',
  'qa',
  'ro',
  'lc',
  'sm',
  'st',
  'sa',
  'rs',
  'sc',
  'sk',
  'si',
  'es',
  'se',
  'ch',
  'tl',
  'tn',
  'tr',
  'ua',
  'ae',
  'va',
]

export const defaultBankNumberFormat = (countryCode: string) => {
  let defaultFormat: BankingEntitiesBankAccountNumberFormatEnum
  if (countryCode === 'mx') {
    defaultFormat = 'clabe'
  } else if (['gb', 'ie'].includes(countryCode)) {
    defaultFormat = 'sort_code_and_account_number'
  } else if (countryCode === 'us') {
    defaultFormat = 'routing_number_and_account_number'
  } else if (countryCode === 'br') {
    defaultFormat = 'bank_name_and_account_number'
  } else if (countriesWithIBAN.includes(countryCode)) {
    defaultFormat = 'iban'
  } else {
    defaultFormat = 'other'
  }

  return defaultFormat
}

export const accountNumberLabel = (
  accountNumberFormat: BankingEntitiesBankAccountNumberFormatEnum
) => {
  switch (accountNumberFormat) {
    case 'iban':
      return i18n.t('employee_form.bank_info.iban')
    case 'sort_code_and_account_number':
      return i18n.t('employee_form.bank_info.account_number')
    case 'routing_number_and_account_number':
      return i18n.t('employee_form.bank_info.account_number')
    case 'clabe':
      return i18n.t('employee_form.bank_info.clabe')
    case 'bank_name_and_account_number':
      return i18n.t('employee_form.bank_info.account_number')
    default:
      return i18n.t('employee_form.bank_info.account_number')
  }
}

export const accountNumberExtraFieldLabel = (
  accountNumberFormat: BankingEntitiesBankAccountNumberFormatEnum
) => {
  switch (accountNumberFormat) {
    case 'iban':
      return i18n.t('employee_form.bank_info.swift_bic')
    case 'sort_code_and_account_number':
      return i18n.t('employee_form.bank_info.sort_code')
    case 'routing_number_and_account_number':
      return i18n.t('employee_form.bank_info.routing_number')
    case 'bank_name_and_account_number':
      return i18n.t('employee_form.bank_info.bank_name')
    case 'clabe':
    case 'other':
      return undefined
  }
}
